import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stringtodemandcomment'
})
export class StringtodemandcommentPipe implements PipeTransform {

  transform(details: any): unknown {
    const arra = []
    details.forEach(element => {
      if (element?.toString().includes(",")) {
        let obj: any = {
          description: "",
          comment: "",
          demandNo: 0
        }
        let arr = element.split(",");
        if (arr && arr.length > 0) {
          obj.demandNo = +arr[0];
          obj.description = arr[1];
          obj.comment = arr[2];
        }

        arra.push(obj);
      }

    })
    return arra;
  }

}
